import { Injectable } from '@angular/core';
import { AppSettings } from '../../../../app.settings';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  activePlanUrl = `${AppSettings.API_ENDPOINT}/${'get-active-plan'}`;
  purchaseUrl = `${AppSettings.API_ENDPOINT}/${'get-payment-history'}`;
  usageUrl = `${AppSettings.API_ENDPOINT}/${'get-usage-details'}`;
  profileUrl = `${AppSettings.API_ENDPOINT}/${'profile-details'}`;
  authenticationUrl = `${AppSettings.API_ENDPOINT}/${'get-2fa-details'}`;
  updateTwoFactAuthenticationUrl = `${AppSettings.API_ENDPOINT}/${'set-2fa-details'}`;
  updatePasswordUrl = `${AppSettings.API_ENDPOINT}/${'change-password'}`;
  updateProfileUrl = `${AppSettings.API_ENDPOINT}/${'profile-logo-upload'}`;
  companyLogoUrl = `${AppSettings.API_ENDPOINT}/${'company-logo-details'}`;
  updateCompanyLogoUrl = `${AppSettings.API_ENDPOINT}/${'company-logo-upload'}`;
  subscriptionUrl = `${AppSettings.API_ENDPOINT}/${'paid-plan'}`;
  fileUploadPerAgentUrl = `${AppSettings.API_ENDPOINT}/${'update-maximum-file-for-agent'}`;
  companylogoBS:BehaviorSubject<any> = new BehaviorSubject<any>({});

  constructor(private http: HttpClient) { }

  getActivePlan(){
    return this.http.get(this.activePlanUrl);
  }

  getPurchase(){
    return this.http.get(this.purchaseUrl);
  }

  getUsage(){
    return this.http.get(this.usageUrl);
  }

  getProfile(){
    return this.http.get(this.profileUrl);
  }

  getAuthentication(){
    return this.http.get(this.authenticationUrl);
  }

  updateTwoWayAuthentication(data:any){
    return this.http.post(this.updateTwoFactAuthenticationUrl, data);
  }

  updatePassword(data:any){
    return this.http.post(this.updatePasswordUrl, data);
  }

  updateProfile(data:any){
    return this.http.post(this.updateProfileUrl, data);
  }

  getCompanyLogo(){
    return this.http.get(this.companyLogoUrl);
  }

  updateCompanyLogo(data:any){
    return this.http.post(this.updateCompanyLogoUrl, data);
  }

  getSubscription(data:any){
    return this.http.post(this.subscriptionUrl, data);
  }

  updateAgentFileUploadCount(data:any) {
    return this.http.post(this.fileUploadPerAgentUrl, data);
  }
}
